// src/pages/ContactPage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import UElogo from "../assets/UElogo_horizontal.png";
import { ArrowBigLeft } from "lucide-react";
import { sendContactEmail } from "../utils/sendEmail"; // ✅ add this

export default function ContactPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const validateEmail = (email) =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

  // ✅ make this async
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!name || !email || !message) {
      setError("Please fill in all fields.");
      return;
    }
    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      // ✅ use the helper (it already knows serviceId, templateId, to_email, and publicKey)
      await sendContactEmail({
        from_name: name,
        from_email: email,
        message,
      });

      setSent(true);
      setName("");
      setEmail("");
      setMessage("");
    } catch (err) {
      console.error("Email send error:", err);
      setError("Failed to send message. Please try again later.");
    }
  };

  const goBack = () => navigate(-1);
  const goToTerms = () => navigate("/terms-of-use");

  return (
    <div className="flex flex-col p-6 pt-28 w-full justify-start min-h-screen bg-gray-800 text-gray-100 p-8">
      {/* Top bar with logo and buttons */}
      <div className="w-full flex justify-between items-center px-6 py-4 absolute top-0 left-0">
        <img src={UElogo} alt="UE Logo" className="h-12 w-auto" />
        <div className="flex gap-4">
          <button
            onClick={goBack}
            className="bg-gray-500 hover:bg-gray-600 text-white px-3 py-1.5 rounded"
          >
            <ArrowBigLeft className="w-5 h-5 text-white" />
          </button>
        </div>
      </div>

      <h1 className="w-full mb-8 text-left px-6 text-xl font-bold">Contact Us</h1>

      <p className="text-gray-300 mb-4">
        This form is intended <strong>only for reporting issues or problems</strong> with the
        platform.
        <br />
        Reservation requests sent through this form <strong>will not be considered</strong>.
      </p>

      <div className="flex flex-col items-center justify-start bg-gray-800 text-gray-100 p-8">
        <form onSubmit={handleSubmit} className="w-full max-w-md space-y-4">
          <div>
            <label className="block mb-1 text-sm">Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="w-full p-2 rounded bg-gray-700 text-white"
            />
          </div>

          <div>
            <label className="block mb-1 text-sm">Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full p-2 rounded bg-gray-700 text-white"
            />
          </div>

          <div>
            <label className="block mb-1 text-sm">Message</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              rows={5}
              className="w-full p-2 rounded bg-gray-700 text-white"
            ></textarea>
          </div>

          <div className="flex justify-center">
            <button type="submit" className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded">
              Send
            </button>
          </div>

          {sent && <p className="text-green-400 mt-4">Your message has been sent.</p>}
          {error && <p className="text-red-400 mt-4">{error}</p>}
        </form>
      </div>

      <button onClick={goToTerms} className="mt-auto pt-[1cm] text-sm text-gray-400 text-center">
        Terms of Use
      </button>
    </div>
  );
}

